import React from 'react';
import PropTypes from 'prop-types';

import Link from '@zola/zola-ui/src/components/Link/Link';

const NavArrowLink = ({ children, href, newTag, inlineFontIcon, onClick, rel, role, target }) => (
  <Link arrow href={href} onClick={onClick} rel={rel} role={role} target={target}>
    {children}
    {newTag && <span className="nav-temp-new-badge">New</span>}
    {inlineFontIcon && (
      <i className={`nav-inline-icon zola-ui-icon zola-ui-icon-${inlineFontIcon}`} />
    )}
  </Link>
);

NavArrowLink.propTypes = {
  href: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
  target: PropTypes.string,
  rel: PropTypes.string,
  role: PropTypes.string,
  onClick: PropTypes.func,
  newTag: PropTypes.bool,
  inlineFontIcon: PropTypes.string,
};

export default NavArrowLink;
